// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Error404 from "@JohnLewisPartnership/jl-design-system/dist/components/error-404/Error404";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Error500 from "@JohnLewisPartnership/jl-design-system/dist/components/error-500/Error500";

export { Error404, Error500 };
